import FaBeer from 'react-icons/lib/fa/beer';

export default {
  'beer': FaBeer,
  'tasks.': FaBeer,
}


// WEBPACK FOOTER //
// ./src/components/Verification/Timeline/icons.js